var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('textarea',{staticClass:"min-h-12 px-4 bg-opacity-10 pt-2",class:{
    'bg-critical border-critical': _vm.error,
    'bg-primary border-primary': !_vm.error,
    'opacity-75 pointer-events-none': _vm.disabled,
    'border-1': !_vm.borderless,
},attrs:{"rows":"1"},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"focus":function($event){return _vm.$emit('focus')},"blur":function($event){return _vm.$emit('blur')},"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }